import {FC} from 'react';

interface QuantityInputProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  className?: string;
}

const buttonClasses =
  'text-expertGray3 h-full w-6 cursor-pointer outline-none flex-none basis-[28px] ';
export const QuantityInput: FC<QuantityInputProps> = ({
  quantity,
  onQuantityChange,
  className = '',
}) => (
  <div
    className={`flex flex-row h-12 rounded-lg relative bg-transparent border-[1px] border-solid border-codGray100 ${className}`}
  >
    <button
      data-action="decrement"
      className={`${
        quantity < 2 ? 'opacity-50' : ''
      } ${buttonClasses} rounded-l `}
      onClick={() => onQuantityChange(quantity - 1)}
      disabled={quantity < 2}
    >
      <span className="m-auto text-2xl font-thin">{`−`}</span>
    </button>
    <input
      type="text"
      className="outline-none px-0 focus:outline-none text-center bg-transparent text-md  md:text-basecursor-default border-none  min-w-[1px]"
      name="custom-input-number"
      aria-label="Item Quantity Select"
      value={quantity}
      onChange={(e) => onQuantityChange(parseInt(e.target.value, 10))}
    />
    <button
      data-action="increment"
      className={`${buttonClasses} rounded-r`}
      onClick={() => onQuantityChange(quantity + 1)}
    >
      <span className="m-auto text-2xl font-thin">+</span>
    </button>
  </div>
);
